import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.sort";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.map";
import { PermissionStatus } from "./Permissions.types";
export function coalesceStatuses(permissions) {
  var statuses = Object.keys(permissions).map(function (type) {
    return permissions[type].status;
  });
  statuses.sort(function (status1, status2) {
    return _getStatusWeight(status1) - _getStatusWeight(status2);
  });
  return statuses[statuses.length - 1];
}

function _getStatusWeight(status) {
  switch (status) {
    case PermissionStatus.GRANTED:
      return 0;

    case PermissionStatus.DENIED:
      return 1;

    case PermissionStatus.UNDETERMINED:
      return 2;

    default:
      return 100;
  }
}

export function coalesceExpirations(permissions) {
  var maxExpiration = 9007199254740991;
  var expirations = Object.keys(permissions).map(function (type) {
    return permissions[type].expires;
  });
  expirations.sort(function (e1, e2) {
    return (e1 == null || e1 === 'never' ? maxExpiration : e1) - (e2 == null || e2 === 'never' ? maxExpiration : e2);
  });
  return expirations[0];
}
export function coalesceCanAskAgain(permissions) {
  return Object.keys(permissions).reduce(function (canAskAgain, type) {
    return canAskAgain && permissions[type].canAskAgain;
  }, true);
}
export function coalesceGranted(permissions) {
  return Object.keys(permissions).reduce(function (granted, type) {
    return granted && permissions[type].granted;
  }, true);
}